import { combineAccessInputs, mapAccessInput, type AccessInput } from '@/abilities/accessInput';
import { createCaseAbility } from '@/abilities/createCaseAbility';
import { treeDestinationAccess, type DestinationAccess } from '@/abilities/destination';
import {
  companyWorkspaceAccessContext,
  type CompanyWorkspaceAccessContext,
  type CompanyWorkspaceAccessValues,
} from '@/abilities/companyWorkspace/context';
import { companyWorkspaceRules } from '@/abilities/companyWorkspace/rules';
import {
  companyWorkspaceDestinationTree,
  toCompanyWorkspaceDestination,
  type CompanyWorkspaceAction,
  type CompanyWorkspaceDestination,
  type CompanyWorkspaceDestinationKey,
} from '@/abilities/companyWorkspace/vocabulary';

/** How the user may reach each destination of the company workspace; the only answer the case gives. */
export type CompanyWorkspaceAccess = {
  readonly accessOf: (destination: CompanyWorkspaceDestinationKey) => DestinationAccess;
};

export type CompanyWorkspaceAccessInputs = {
  readonly [Key in keyof CompanyWorkspaceAccessValues]: AccessInput<CompanyWorkspaceAccessValues[Key]>;
};

export const companyWorkspaceAccessOf = (ctx: CompanyWorkspaceAccessContext): CompanyWorkspaceAccess => ({
  accessOf: treeDestinationAccess(
    createCaseAbility<CompanyWorkspaceAction, CompanyWorkspaceDestination>(companyWorkspaceRules(ctx)),
    toCompanyWorkspaceDestination,
    companyWorkspaceDestinationTree,
  ),
});

export const companyWorkspaceAccess = (inputs: CompanyWorkspaceAccessInputs): AccessInput<CompanyWorkspaceAccess> =>
  mapAccessInput(combineAccessInputs(inputs), (values) =>
    companyWorkspaceAccessOf(companyWorkspaceAccessContext(values)),
  );
